export const viewName = "view";
export const measureTypeName = "measureType";
export const objectName = "object";
export const idObjectName = "idObject";
export const idParameterName = "idParameter";
export const idMeasureName = "idMeasure";
export const idObjectsOptionsName = "idObjectsOptions";
export const idParametersOptionsName = "idParametersOptions";
export const idMeasuresOptionsName = "idMeasuresOptions";

export const lineColors = [
  "#f44336",
  "#2196f3",
  "#8e24aa",
  "#6ec6ff",
  "#cddc39",
  "#ff9800",
  "#5c007a",
  "#d84315",
  "#9f0000",
  "#4caf50",
  "#f50057",
  "#000063",
  "#311b92",
];
